import React from "react";
import Styles from './styles.module.scss';

import logo from '../../../theme/assets/other/ftf_cabinet_logo.png';



const FtfLogo = () => {

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <div className={`${Styles.imgWrap}`}>
                    <img src={logo} alt="F#ck the Fomo"/>
                </div>
                <div className={`${Styles.text}`}>F#ck the Fomo</div>
            </div>
        </section>
    );
};

export default FtfLogo;